import React from 'react';
import { LoadingPlaceholder } from '../Components/Placeholder';
import { PaymentSchemeDisplaySection } from './PaymentSchemeDisplaySection';
import styles from './PaymentSchemeDetailsSection.module.css';
import classNames from 'classnames';
export var PaymentSchemeDetailsSection = function (props) {
    var _a;
    if (!props.scheme) {
        return null;
    }
    return (React.createElement("div", { className: classNames(styles.container, (_a = {}, _a[styles.loading] = props.loading, _a)) }, props.loading ? (React.createElement(LoadingPlaceholder, null)) : (React.createElement(React.Fragment, null,
        !!props.scheme.cautionsHtmlText && (React.createElement(PaymentSchemeDisplaySection, { readOnly: props.readOnly, title: 'Caution', innerHtml: props.scheme.cautionsHtmlText })),
        !!props.scheme.notesHtmlText && (React.createElement(PaymentSchemeDisplaySection, { readOnly: props.readOnly, title: 'Notes', innerHtml: props.scheme.notesHtmlText })),
        props.scheme.indications.map(function (indication) { return (React.createElement(PaymentSchemeDisplaySection, { key: indication.code, readOnly: props.readOnly, title: "#" + indication.displayCode, innerHtml: indication.indicationHtmlText, active: props.chosenIndicationCode === indication.code, onClick: function () {
                if (props.onIndicationChosen && props.scheme)
                    props.onIndicationChosen(props.scheme, indication);
            }, indication: indication })); })))));
};
